class RecommendationQuiz {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.currentQuestion = 1;
    this.totalQuestions = 4;
    this.answers = {
      concern: null,
      severity: null,
      lifestyle: null,
      contacts: null
    };
    this.recommendedCollection = null;

    this.init();
  }

  init() {
    this.form = document.getElementById(`quiz-form-${this.sectionId}`);
    this.nextBtn = document.getElementById(`next-btn-${this.sectionId}`);
    this.prevBtn = document.getElementById(`prev-btn-${this.sectionId}`);
    this.progressBar = document.getElementById(`progress-${this.sectionId}`);
    this.progressText = document.getElementById(`progress-text-${this.sectionId}`);
    this.resultsSection = document.getElementById(`quiz-results-${this.sectionId}`);
    this.resultsCta = this.resultsSection ? this.resultsSection.querySelector('.results-cta') : null;

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.nextQuestion();
    });

    this.prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.prevQuestion();
    });

    // Listen to radio changes to enable next button
    const radios = this.form.querySelectorAll('input[type="radio"]');
    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        this.updateAnswers();
        this.validateQuestion();
      });
    });
  }

  updateAnswers() {
    const concern = this.form.querySelector('input[name="concern"]:checked');
    const severity = this.form.querySelector('input[name="severity"]:checked');
    const lifestyle = this.form.querySelector('input[name="lifestyle"]:checked');
    const contacts = this.form.querySelector('input[name="contacts"]:checked');

    if (concern) this.answers.concern = concern.value;
    if (severity) this.answers.severity = severity.value;
    if (lifestyle) this.answers.lifestyle = lifestyle.value;
    if (contacts) this.answers.contacts = contacts.value;
  }

  validateQuestion() {
    const questions = ['concern', 'severity', 'lifestyle', 'contacts'];
    const currentField = questions[this.currentQuestion - 1];
    const isAnswered = this.form.querySelector(`input[name="${currentField}"]:checked`);

    this.nextBtn.disabled = !isAnswered;
  }

  nextQuestion() {
    this.updateAnswers();

    if (this.currentQuestion < this.totalQuestions) {
      this.currentQuestion++;
      this.showQuestion();
    } else if (this.currentQuestion === this.totalQuestions) {
      this.showResults();
    }
  }

  prevQuestion() {
    if (this.currentQuestion > 1) {
      this.currentQuestion--;
      this.showQuestion();
    }
  }

  showQuestion() {
    // Hide all questions
    const questions = this.form.querySelectorAll('.quiz-question');
    questions.forEach(q => q.classList.remove('active'));

    // Show current question
    const currentQ = this.form.querySelector(`[data-question="${this.currentQuestion}"]`);
    if (currentQ) currentQ.classList.add('active');

    // Update buttons visibility
    this.prevBtn.style.display = this.currentQuestion > 1 ? 'block' : 'none';
    this.nextBtn.textContent = this.currentQuestion === this.totalQuestions ? 'See Recommendations →' : 'Next →';

    // Update progress
    this.updateProgress();

    // Reset next button state
    this.validateQuestion();

    // Scroll to top
    window.scrollTo({ top: this.form.offsetTop - 100, behavior: 'smooth' });
  }

  updateProgress() {
    const percentage = (this.currentQuestion / this.totalQuestions) * 100;
    this.progressBar.style.width = percentage + '%';
    this.progressText.textContent = `${this.currentQuestion} of ${this.totalQuestions}`;
  }

  showResults() {
    // Hide form
    this.form.style.display = 'none';

    // Show results
    this.resultsSection.style.display = 'block';

    // Determine recommendation based on answers
    this.recommendedCollection = this.getRecommendation();

    // Display recommendation
    this.displayRecommendation();

    // Scroll to results
    window.scrollTo({ top: this.resultsSection.offsetTop - 100, behavior: 'smooth' });
  }

  getRecommendation() {
    const concern = this.answers.concern;
    const severity = this.answers.severity;

    // Map concerns to collections
    const collectionMap = {
      'dry-eyes': {
        collection: 'eye-masks-goggles-for-dry-eyes',
        name: 'Eye Masks & Goggles for Dry Eyes',
        description: 'Find relief with our curated selection of eye masks, hydrating treatments, and protective gear designed specifically for dry eye syndrome.'
      },
      'eyelid-health': {
        collection: 'eyelid-hygiene-products-for-clean-healthy-eyes',
        name: 'Eyelid Hygiene Products',
        description: 'Keep your eyelids clean and healthy with our doctor-approved cleansing products and treatments.'
      },
      'allergies': {
        collection: 'artificial-tears',
        name: 'Artificial Tears & Relief',
        description: 'Quick relief from allergies and irritation. Our artificial tear solutions provide instant comfort and long-lasting protection.'
      },
      'tired-eyes': {
        collection: 'eye-masks-goggles-for-dry-eyes',
        name: 'Eye Masks & Goggles for Tired Eyes',
        description: 'Refresh and rejuvenate tired eyes with our comfortable, therapeutic eye masks and rest solutions.'
      }
    };

    return collectionMap[concern] || collectionMap['dry-eyes'];
  }

  displayRecommendation() {
    const container = document.getElementById(`recommended-collection-${this.sectionId}`);
    const collection = this.recommendedCollection;

    container.innerHTML = `
      <div class="recommended-collection-info">
        <p class="recommended-collection-name">${collection.name}</p>
        <p class="recommended-collection-description">${collection.description}</p>
      </div>
    `;

    // Update CTA button
    if (this.resultsCta) {
      this.resultsCta.setAttribute('data-link', `/collections/${collection.collection}`);
      this.resultsCta.addEventListener('click', () => {
        window.location.href = `/collections/${collection.collection}`;
      });
    }
  }
}

// Initialize quiz when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  const quizSections = document.querySelectorAll('[data-section-id]');
  quizSections.forEach(section => {
    const sectionId = section.getAttribute('data-section-id');
    if (sectionId && section.classList.contains('recommendation-quiz-wrapper')) {
      new RecommendationQuiz(sectionId);
    }
  });
});

// Reset quiz function
function resetQuiz(sectionId) {
  const quiz = new RecommendationQuiz(sectionId);
  quiz.currentQuestion = 1;
  quiz.answers = { concern: null, severity: null, lifestyle: null, contacts: null };

  // Clear all checked inputs
  const form = document.getElementById(`quiz-form-${sectionId}`);
  form.querySelectorAll('input[type="radio"]').forEach(radio => {
    radio.checked = false;
  });

  quiz.showQuestion();
}
